jQuery(document).ready(function() {
  jQuery(window).scroll(function() {
    var sticky = jQuery(".fixshare"),
      scroll = jQuery(window).scrollTop();

    if (scroll >= 500) sticky.addClass("sharefixed");
    else sticky.removeClass("sharefixed");

    if (isScrolledIntoView(jQuery("#sharefoot"))) {
      sticky.css("opacity", "0");
    } else if (isScrolledIntoView(jQuery(".homesubscribecoverbox"))) {
      sticky.css("opacity", "0");
    } else if (isScrolledIntoView(jQuery(".site-footer"))) {
      sticky.css("opacity", "0");
    } else {
      sticky.css("opacity", "1");
    }
  });
  function isScrolledIntoView(elem) {
    if ($(elem).length) {
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();
      var elemTop = $(elem).offset().top;
      var elemBottom = elemTop + $(elem).height();
      return (
        elemBottom >= docViewTop &&
        elemTop <= docViewBottom &&
        elemBottom <= docViewBottom &&
        elemTop >= docViewTop
      );
    }
  }
});
